module.exports = __webpack_public_path__ + "02_hair_brown.2a4eccb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/02_hair_brown.png
// module id = bz4S
// module chunks = 0